/* ── Curva Sneakers MX — Theme JS ──────────────────────────────────────────── */

const CartAPI = {
  async get() { const r = await fetch('/cart.js'); return r.json(); },
  async add(variantId, quantity = 1) {
    const r = await fetch('/cart/add.js', {
      method: 'POST', headers: { 'Content-Type': 'application/json' },
      body: JSON.stringify({ id: variantId, quantity })
    }); return r.json();
  },
  async update(updates) {
    const r = await fetch('/cart/update.js', {
      method: 'POST', headers: { 'Content-Type': 'application/json' },
      body: JSON.stringify({ updates })
    }); return r.json();
  },
  async change(key, quantity) {
    const r = await fetch('/cart/change.js', {
      method: 'POST', headers: { 'Content-Type': 'application/json' },
      body: JSON.stringify({ id: key, quantity })
    }); return r.json();
  }
};

function openCart() {
  document.getElementById('CartDrawer').classList.add('open');
  document.getElementById('CartOverlay').classList.add('open');
  document.body.style.overflow = 'hidden';
  refreshCartDrawer();
}

function closeCart() {
  document.getElementById('CartDrawer').classList.remove('open');
  document.getElementById('CartOverlay').classList.remove('open');
  document.body.style.overflow = '';
}

async function refreshCartDrawer() {
  const cart = await CartAPI.get();
  const container = document.getElementById('CartItems');
  const totalEl = document.getElementById('CartTotal');
  const countEls = document.querySelectorAll('#CartCount, .footer-nav__badge');

  countEls.forEach(el => {
    el.textContent = cart.item_count;
    el.style.display = cart.item_count > 0 ? 'flex' : 'none';
  });

  if (totalEl) totalEl.textContent = formatMoney(cart.total_price);
  if (!container) return;

  if (cart.items.length === 0) {
    container.innerHTML = `<div class="cart-empty" style="padding:40px 20px;text-align:center"><span class="material-icons" style="font-size:48px;color:var(--text-muted)">shopping_bag</span><p style="margin-top:12px;color:var(--text-muted)">Tu carrito está vacío</p></div>`;
    return;
  }

  container.innerHTML = cart.items.map(item => `
    <div class="cart-item" data-key="${item.key}">
      <a href="${item.url}" class="cart-item__img-wrap">
        <img src="${item.image}" alt="${item.title}" class="cart-item__img">
      </a>
      <div class="cart-item__info">
        <a href="${item.url}" class="cart-item__name">${item.product_title}</a>
        ${item.variant_title !== 'Default Title' ? `<span class="cart-item__variant text-muted">${item.variant_title}</span>` : ''}
        <div class="cart-item__row">
          <div class="quantity-picker">
            <button onclick="drawerChangeQty('${item.key}', ${item.quantity - 1})">−</button>
            <span>${item.quantity}</span>
            <button onclick="drawerChangeQty('${item.key}', ${item.quantity + 1})">+</button>
          </div>
          <span class="cart-item__price">${formatMoney(item.final_line_price)}</span>
        </div>
      </div>
      <button class="cart-item__remove icon-btn" onclick="drawerChangeQty('${item.key}', 0)">
        <span class="material-icons">delete_outline</span>
      </button>
    </div>
  `).join('');
}

async function drawerChangeQty(key, qty) {
  await CartAPI.change(key, qty);
  refreshCartDrawer();
}

async function addToCart(variantId, quantity = 1) {
  const btn = document.getElementById('AddToCartBtn');
  if (btn) { btn.disabled = true; btn.classList.add('loading'); }
  try {
    await CartAPI.add(variantId, quantity);
    openCart();
  } catch (err) {
    showToast('Error al agregar al carrito');
  } finally {
    if (btn) { btn.disabled = false; btn.classList.remove('loading'); }
  }
}

async function updateQuantity(key, quantity) {
  await CartAPI.change(key, quantity);
  window.location.reload();
}

function formatMoney(cents) {
  return new Intl.NumberFormat('es-MX', { style: 'currency', currency: 'MXN', minimumFractionDigits: 0 }).format(cents / 100);
}

function showToast(msg) {
  const el = document.createElement('div');
  el.className = 'curva-toast';
  el.textContent = msg;
  document.body.appendChild(el);
  requestAnimationFrame(() => el.classList.add('show'));
  setTimeout(() => { el.classList.remove('show'); setTimeout(() => el.remove(), 300); }, 2500);
}

document.addEventListener('click', function(e) {
  const menu = document.getElementById('MobileMenu');
  if (!menu) return;
  if (!menu.contains(e.target) && !e.target.closest('.icon-btn[onclick*="MobileMenu"]')) menu.classList.remove('open');
});

document.addEventListener('DOMContentLoaded', () => {
  CartAPI.get().then(cart => {
    document.querySelectorAll('#CartCount').forEach(el => {
      el.textContent = cart.item_count;
      el.style.display = cart.item_count > 0 ? 'flex' : 'none';
    });
  });
  document.addEventListener('keydown', e => { if (e.key === 'Escape') closeCart(); });
  initWishlists();
});


// ── Wishlist ──────────────────────────────────────────────────────────────────
const WishlistAPI = {
  KEY: 'curva_wishlist',
  get() { try { return JSON.parse(localStorage.getItem(this.KEY)||'[]'); } catch { return []; } },
  save(list) { localStorage.setItem(this.KEY, JSON.stringify(list)); this._badge(list.length); },
  has(id) { return this.get().some(p => String(p.id)===String(id)); },
  add(p) { const l=this.get(); if(!l.some(x=>String(x.id)===String(p.id))){ l.push(p); this.save(l); } },
  remove(id) { this.save(this.get().filter(p=>String(p.id)!==String(id))); },
  toggle(p) { if(this.has(p.id)){ this.remove(p.id); return false; } this.add(p); return true; },
  clear() { this.save([]); },
  _badge(count) { document.querySelectorAll('.wishlist-badge').forEach(el=>{ el.textContent=count; el.style.display=count>0?'flex':'none'; }); }
};

function toggleWishlist(btn) {
  event.preventDefault(); event.stopPropagation();
  const d = btn.dataset;
  const ok = WishlistAPI.toggle({ id:d.productId, handle:d.productHandle, title:d.productTitle, price:d.productPrice, image:d.productImage, url:d.productUrl, variantId:d.variantId });
  const icon = btn.querySelector('.material-icons');
  if(ok){ icon.textContent='favorite'; btn.classList.add('wishlist-active'); showToast('♥ Guardado en tu lista de deseos'); }
  else { icon.textContent='favorite_border'; btn.classList.remove('wishlist-active'); showToast('Eliminado de tu lista de deseos'); }
}

function initWishlists() {
  document.querySelectorAll('[data-wishlist-btn]').forEach(btn => {
    if(WishlistAPI.has(btn.dataset.productId)){ btn.querySelector('.material-icons').textContent='favorite'; btn.classList.add('wishlist-active'); }
  });
  WishlistAPI._badge(WishlistAPI.get().length);
}
